import request from './adminRequest'

export const loginInfoApi = {
  listLoginInfo (params) {
    return request.get('/loginInfos', { params: params })
  },
}
export default loginInfoApi
